import React, { useState } from 'react'
import { io } from 'socket.io-client'
import { primaryColor } from 'assets/jss/material-kit-react.js'
import { useDispatch, useSelector } from 'react-redux'
import { getStorageAccount } from 'redux/actions/accountActions'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { isVeryNarrow } from 'util/screenUtils'
import {
  Snackbar,
  useMediaQuery,
} from '@material-ui/core'
import DisplayHarmonizePost from './DisplayHarmonizePost'
import { displayError } from 'util/screenUtils.js'
import { getAndConnectRoom } from 'controllers/VortexController.js'
import { getPublicUserById } from 'controllers/CoreServiceController'
import { useRef } from 'react'
import { logWithTime } from 'util/screenUtils.js'
import { isAdminUser } from 'util/adminUtils.js'
import harmony from '../images/harmony.jpg'

import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom.js'

import { setPlayList } from 'redux/actions/messagesActions'
import { setPlayListIndex } from 'redux/actions/harmonizeActions'
import { PLAYER_MODES } from 'redux/reducers/harmonizeReducer'
import HarmonizePlayer from 'components/harmonize/HarmonizePlayer'
import { isGooglebot } from 'util/screenUtils'
import { setMessages } from 'redux/actions/messagesActions'
import { setCurrentChannel } from 'redux/actions/messagesActions'
import { setPlayerMode } from 'redux/actions/harmonizeActions'
import { setCurrentCollection } from 'redux/actions/harmonizeActions'
import { getCollections } from 'controllers/SocialServiceController'
import ErrorLine from 'components/ErrorLine'
import Chat from 'components/harmonize/Chat'

import { LIKED_COLLECTION } from 'util/postUtils'
import { STUDIO_COLLECTION } from 'util/postUtils'
import { COLLECTION_TYPE } from 'util/postUtils'
import StudioGrid from 'components/harmonize/StudioGrid'
import HarmonizeHeader from 'components/Header/HarmonizeHeader'
import Footer from 'components/Footer/Footer'
import AIChat from './AIChat'

import DisplaySignIn from 'components/DisplaySignIn'
import { getAccountId } from 'redux/actions/accountActions'
import { setCurrentRoomOwner } from 'redux/actions/messagesActions'
import { setPlayerState } from 'redux/actions/harmonizeActions'
import { PLAYER_STATES } from 'redux/reducers/harmonizeReducer'
import { setPlayCurrentSong } from 'redux/actions/harmonizeActions'
import { isArtistStudio } from 'util/postUtils'
import { isMyStudio } from 'util/postUtils'
import SwipeCard from 'components/harmonize/SwipeCard'
import { buildNewPlaylistEntries } from 'util/playlistUtils'
import { setCollections } from 'redux/actions/harmonizeActions'
import { getConnectionChannel } from 'util/socketUtils'
import { buildPlaylistEntry } from 'util/playlistUtils'
import { updateMessagesAndPlayList } from 'util/playlistUtils'
import { refetchMessage } from 'util/playlistUtils'
import { hasMessages } from 'controllers/SocialServiceController'
import { fetchSongsAndVideo } from 'util/fetchUtils'
import { setFetchInProgress, setQuery, setRefetchMessageId } from 'redux/actions/fetchActions'
import { setFetchStart } from 'redux/actions/fetchActions'
import { setEndOfMessages } from 'redux/actions/messagesActions'
import GoogleBotPage from 'components/seo/GoogleBotPage'


let socket
export default function Studio() {
  //See https://developers.google.com/search/docs/crawling-indexing/overview-google-crawlers
  const veryNarrow = isVeryNarrow(useMediaQuery)
  const { currentArtist } = useSelector(state => state.artist)
  const { requestedSong, requestedCollection } = currentArtist
  const { signedIn } = useSelector(state => state.account)
  const { chatSessionId } = useSelector(state => state.chat)

  const storageAccount = getStorageAccount()
  const userId = getAccountId()
  const username = storageAccount ? storageAccount.username : null
  const { collections, currentCollection, forceSignIn, fullscreen, playerMode, playerState, playListIndex,
    showAi, showChat, showCollections } = useSelector(state => state.harmonize)
  const { currentChannel, currentRoom, endOfMessages, messages, playList, currentRoomOwner }
    = useSelector(state => state.messages)
  const { fetchStart, query, refetchMessageId } = useSelector(state => state.fetch)
  const { reactorPlay } = useSelector(state => state.display)
  const [requestedMessages, setRequestedMessages] = useState()
  const [error, setError] = useState()
  const [queryReady, setQueryReady] = useState(false)
  const [loadFailed, setLoadFailed] = useState(false)

  const [noAccess, setNoAccess] = useState(false)
  const [commentToAdd, setCommentToAdd] = useState()
  const [commentToDelete, setCommentToDelete] = useState()
  const [messageToCreate, setMessageToCreate] = useState()
  const [messageToUpdate, setMessageToUpdate] = useState()
  const [messageToDelete, setMessageToDelete] = useState()
  const [messageToLike, setMessageToLike] = useState()
  const [joinedStudio, setJoinedStudio] = useState(null)
  //const [collections, setStudioCollections] = useState([])
  const history = useHistory()
  const dispatch = useDispatch()
  const ref = useRef()

  const isSignedIn = () => {
    return signedIn
  }
  const getSocket = () => {
    return socket
  }

  /* The following methods are used to track the visibility state of the browser. */
  const [visible, _setVisible] = useState('visible')
  const visibleRef = useRef(visible)
  const setVisible = (data) => {
    visibleRef.current = data
    //logWithTime(`setVisible to ${visibleRef.current}`)
    _setVisible(data)
  }


  /**
     * This will be called e.g. when another page in Harmonize is selected, so don't null the currentRoom.
     * Otherwise going back to this page will have a null currentRoom and do nothing.
  
     * @param {*} resetRoom If true (default) room and messages are reset.
     */
  const channelDisconnected = (resetRoom = true) => {
    setError()
    socket = null
  }

  const [scrollFetchOff, _setScrollFetchOff] = useState(false)

  const scrollFetchOffRef = useRef(scrollFetchOff)
  const setScrollFetchOff = (data) => {
    scrollFetchOffRef.current = data
    _setScrollFetchOff(data)
  }

  const [messagesOffset, _setMessagesOffset] = useState(0)

  const messagesOffsetRef = useRef(messagesOffset)
  const setMessagesOffset = (data) => {
    messagesOffsetRef.current = data
    _setMessagesOffset(data)
  }

  /**
   * THe Message received here is the complete instance sent from
   * SOcial Service
   */
  const createMessage = () => {
    if (messageToCreate) {
      console.log('[]Studio createMessage', messageToCreate)
      console.log(`[]Studio...createMessage messages length ${messages ? messages.length : 'undefined'} 
        playList length ${playList ? playList.length : 'undefined'}`)
      const messageIx = messages.findIndex((m) => m._id === messageToCreate._id)
      const playListIx = playList.findIndex((m) => m.messageId === messageToCreate._id)
      if (messageIx === -1) {
        const update = [
          messageToCreate,
          ...messages.slice(0)
        ]
        console.log('[]Studio...createMessage messages are now', update)
        dispatch(setMessages(update))
      }
      if (playListIx === -1) {
        const newPlayListEntry = buildPlaylistEntry(messageToCreate)
        const update = [
          newPlayListEntry,
          ...playList.slice(0)
        ]
        console.log('[]Studio...createMessage playList is now', update)
        dispatch(setPlayList(update))
      }
      setMessageToCreate(null)
    }
  }
  /**
   * The Message received here is just {messageId}.
   * 
   * To delete a Message remove it from both the messages list
   * and the playList. This is done by using Array slice to get
   * shallow copies of the existing lists, leaving out the
   * deleted entries, then dispatching the updates to the
   * corresponding reducers.
   */
  const deleteMessage = () => {
    if (messageToDelete) {
      console.log('deleteMessage', messageToDelete)
      console.log(`...deleteMessage messages length ${messages ? messages.length : 'undefined'} 
        playList length ${playList ? playList.length : 'undefined'}`)
      const { messageId } = messageToDelete
      const messageIx = messages.findIndex((m) => m._id === messageId)
      const playListIx = playList.findIndex((m) => m.messageId === messageId)
      if (messageIx !== -1) {
        const update = [
          ...messages.slice(0, messageIx),
          ...messages.slice(messageIx + 1),
        ]
        dispatch(setMessages(update))
      }
      if (playListIx !== -1) {
        const update = [
          ...playList.slice(0, playListIx),
          ...playList.slice(playListIx + 1),
        ]
        dispatch(setPlayList(update))
      }
      setMessageToDelete(null)
    }
  }

  /**
   * Update the liked flag in the referenced Message. Increment or decrement the
   * numLikes count for display purposes, but this really should be sent from
   * the Social Service
   */
  const updateLike = () => {
    if (messageToLike) {
      const { messageId, liked } = messageToLike
      const messageIx = messages.findIndex((m) => m._id === messageId)

      if (messageIx !== -1) {
        const likeMessage = messages[messageIx]
        const { numLikes } = likeMessage
        const totalLikes = liked ? numLikes + 1 : numLikes - 1
        const updatedLike = { ...likeMessage, liked, numLikes: totalLikes }
        const update = [
          ...messages.slice(0, messageIx),
          messageToLike,
          ...messages.slice(messageIx + 1),
        ]
        dispatch(setMessages(update))
        const playListIx = playList.findIndex((m) => m.messageId === messageId)
        if (playListIx !== -1) {
          const playListUpdate = [
            ...playList.slice(0, playListIx),
            updatedLike,
            ...playList.slice(playListIx + 1),
          ]
          dispatch(setPlayList(playListUpdate))
        }
      }
    }
    setMessageToLike(null)
  }

  /**
   * When we receive a broadcast updated Message, it contains like information
   * as well as highlights.
   * 
   * An update may change the studio (room) for a Message. Therefore filter out updates
   * that don't belong in the current studio

   * @param {*} message 
   */
  const updateMessage = () => {
    if (messageToUpdate) {
      updateMessagesAndPlayList(messageToUpdate, currentRoom, dispatch)
      setMessageToUpdate(null)
    }
  }

  /**
   * Look for the parent Message in messages, and if found push the newComment into its
   * comments array. If the message is not found the comment is ignored.
   * @returns
   */
  const addCommentToMessage = () => {
    if (commentToAdd) {
      console.log('addCommentToMessage', commentToAdd)
      const { comment, messageId } = commentToAdd
      const message = messages.find((m) => m._id === messageId)
      if (message) {
        if (message.comments) {
          message.comments.push(commentToAdd)
        } else {
          message.comments = [commentToAdd]
        }
        console.log(`...Added comment ${comment} to messageId ${messageId}`)
        dispatch(setMessages([...messages]))
      }
    }
  }

  const deleteCommentFromMessage = () => {
    if (commentToDelete) {
      const { commentId, messageId } = commentToDelete
      const message = messages.find((m) => m._id === messageId)
      if (message && message.comments) {
        message.comments = message.comments.filter((c) => c._id !== commentId)
        console.log(`Deleted comment ${commentId} from messageId ${messageId}`)
        dispatch(setMessages([...messages]))
      }
    }
  }

  /**
   * We DO NOT have to use the redux state in here because the local state is not seen and I don't got
   * the time to figure out why. OK now we know. See:
   * https://stackoverflow.com/questions/55265255/react-usestate-hook-event-handler-using-initial-state
   * @param {*} channel
   */
  const channelConnected = (channel, studioOwner) => {
    console.log(`channelConnected ${channel} `)
    dispatch(setCurrentChannel(channel))
    setError('')
  }


  /** 
   * The only difference between this and connectExisting is that this will get the initial service messages;
   * however there appears to be a race condition in that the socket connection event does not mean
   * the Social Service is listening yet.
   * 
   * Here is some bogosity: if the userId is provided as an element in the io constructor, it cannot
   *  be updated after the first connection. So e.g. if it starts null, and you sign in, even though everything
   * else in here sees the new userId, the io instance does not. SO we changed this up to send
   * a base64 encoded string on the connection request et voila.
   */
  const connectNew = (studioOwner, studio, connectionString) => {
    try {
      let channelPath
      if (connectionString) {
        channelPath = connectionString
      } else {
        channelPath = getConnectionChannel(studio)
      }
      const channelAddress = `${process.env.REACT_APP_SOCIAL_CHAT_SERVICE}${channelPath}`
      logWithTime(`Attempt new connection to ${channelAddress} currentCollection`, currentCollection)
      socket = io(channelAddress, {
        reconnectionDelay: 10000
      })
      socketActions(socket, channelPath, studioOwner)
      socket.on('joined', () => {
        setJoinedStudio(studio)
      })
    } catch (error) {
      console.error(error)
      displayError(error, setError, 101)
    }
  }

  const onJoined = async () => {
    setQueryReady(false)
    const isArtist = await hasMessages()
    console.log(`onJoined isArtist ${isArtist}`)

    //Only show currentCollection if it belongs to this room
    logWithTime('...joined to studio, now getInitialMessages', joinedStudio)
    if (joinedStudio) {
      logWithTime(`...studiosCollectionsfor ${getAccountId()}`, collections)
      let user, retrieveCollection
      if (currentCollection && currentCollection.roomId === joinedStudio._id) {
        retrieveCollection = currentCollection
      } else if (collections.length) {
        const defaultCollection = collections.length === 1 ? collections[0] :
          collections.find(col => col.name === isArtist ? 'Studio' : 'Liked')
        retrieveCollection = defaultCollection
      }
      console.log(`\n ***>initial currentCollection request ${user} `, retrieveCollection)

      getInitialMessages()

    }

    setJoinedStudio(null)
  }

  const connectExisting = () => {
    logWithTime(`Connect to existing ${currentChannel}`)
    try {
      const channelAddress = `${process.env.REACT_APP_SOCIAL_CHAT_SERVICE}${currentChannel}`
      //console.log(`Reconnect to ${channelAddress}`)
      socket = io(channelAddress, {
        reconnectionDelay: 10000,
      })
      socketActions(socket, currentChannel, currentRoomOwner)
    } catch (error) {
      console.error(error)
      setError(error)
    }
  }

  /**
   * "Event handlers shouldn't be registered in the connect handler itself, 
   * as a new handler will be registered every time the socket instance reconnects:"
   * 
   * @see https://socket.io/docs/v4/client-api/#event-connect
   * @param {*} socket 
   */
  const socketActions = (socket, channel, studioOwner) => {
    //When the Social Service is killed with active connections this gets called back with a null socket
    if (socket) {
      socket.on('connect', () => {
        channelConnected(channel, studioOwner)
      })
      socket.on('connect_error', () => {
        displayError({ message: `Unable to connect to Harmonize Social Service` }, setError, 102)
        if (socket) {
          socket.disconnect()
        }
      })

      socket.on('unauthorized', () => {
        channelDisconnected(channel)
        setError('You are not signed in')
        history.replace('/SignIn')
      })
      socket.on('disconnect', () => {
        //console.log(`received socket disconnect IGNORED`)
        //channelDisconnected()
      })
      socket.on('addComment', (comment) => {
        console.log('addComment received comment', comment)
        setCommentToAdd(comment)
      })
      socket.on('deleteComment', (comment) => {
        console.log('deleteComment', comment)
        setCommentToDelete(comment)
      })

      socket.on('createdMessage', async (message) => {
        console.log('[]Studio createdMessage received message', message)
        setMessageToCreate(message)
      })

      socket.on('liked', async (messageId) => {
        console.log('liked', messageId)
        setMessageToLike({ messageId, liked: true })
      })
      socket.on('unliked', async (messageId) => {
        console.log('unliked', messageId)
        setMessageToLike({ messageId, liked: false })
      })
      socket.on('updatedMessage', async (message) => {
        console.log('[]Studio updatedMessage received message', message)
        setMessageToUpdate(message)
      })
      socket.on('deleteMessage', (message) => {
        console.log('deleteMessage', message)
        setMessageToDelete(message)
      })
      /*
      socket.on('requestedMessages', async (messages) => {
        setRequestedMessages(messages)
        setScrollFetchOff(false)
      })
      */
      socket.on('error', (message) => {
        displayError(message, setError, 103)
      })
    }
  }
  /**
   * This disconnects the socket but leaves everything else in place.
   */
  const disconnectExisting = () => {

    logWithTime(
      socket ? 'disconnectExisting' : 'WARNING no socket for disconnectExisting'
    )
    leaveRoom()
    socket = null
  }

  const disconnectChannel = (resetRoom) => {
    console.log(`disconnectChannel resetRoom ${resetRoom}`, socket)
    leaveRoom()
    channelDisconnected(resetRoom)
  }

  /**
   * Request messages from the Social Service either:
   * 1) By the currentCollection. This works in any Studio.
   * 2) For this Studio. This only makes sense in an artist Studio, i.e., a Studio in which Messages have been posted
   * 
   * The reqeustingUserId is obtained in the SOcial Service by the x-user-id header and should not be
   * sent with the query.
   * @param {*} requestedCollection 
   * @param {*} noDefault If true don't fall back to requestedSong or requestedCollection
   */
  const getInitialMessages = (requestedCollection, noDefault, roomParams) => {
    console.log('\n[]Studio ***>getInitialMessages', requestedCollection)
    let roomId, username
    if (roomParams) {
      const { room, roomOwner } = roomParams
      roomId = room._id
      username = roomOwner.username
    } else {
      roomId = currentRoom._id
      username = currentRoomOwner.username
    }
    let query = { roomId, start: 0, count: parseInt(process.env.REACT_APP_FETCH_BLOCK_SIZE) }
    //setMessagesOffset(0)
    dispatch(setEndOfMessages(false))
    dispatch(setFetchStart(0))
    dispatch(setMessages([]))
    dispatch(setPlayList([]))
    dispatch(setPlayListIndex(0))
    //dispatch(setContinuousPlay(false))
    /* Disable scroll on fetch because if the messages retrieved are too short display-wise another fetch is triggered */
    setScrollFetchOff(true)
    if (requestedCollection) {
      const { _id: collectionId, collectionType } = requestedCollection
      if (collectionType !== COLLECTION_TYPE.STUDIO) {
        query = { collectionId, collectionType }
      }
    } else if (!noDefault) {
      if (requestedSong) {
        query = { username, requestedSong }
      } else if (requestedCollection) {
        query = { collectionId: requestedCollection }
      }
    }
    console.log('[]Studio...getInitialMessages query', query)
    setScrollFetchOff(false)
    dispatch(setQuery(query))
    setQueryReady(true)
  }

  const leaveRoom = () => {
    if (socket) {
      safeEmit('leaveRoom', { userId, username })
    }
  }

  const leaveChat = () => {
    if (socket) {
      safeEmit('chatleave', { userId, username })
    }
  }


  const getRoomOwner = async (room) => {
    console.log('getRoomOwner', room)
    const { user } = room
    const publicUser = await getPublicUserById(user)
    if (publicUser.status === 200) {
      const owner = { ...publicUser, user }
      console.log('Room owner', owner)
      dispatch(setCurrentRoomOwner(owner))
      if (!isSpecificRequest() && playerState === PLAYER_STATES.SONG) {
        console.log(`getRoomOwner set playerState to PLAYER_STATES.STUDIO`)
        dispatch(setPlayerState(PLAYER_STATES.STUDIO))
      }
      return owner
    } else {
      return null
    }
  }

  /**
   * A playList comprises one entry for every message that has an mp3.
   * The entry comprises an array with an entry for each mp3 or mp4 file.
   * 
   * NOTE: On 8/1/2024 MP3s started being created on the Core Service and not in Backblaze.
   * As a result there are two Core Service endpoints.
   
   * @param {*} newMessages The messages for the playList.
   * @param {*} initialize  If true this is the first set in the playlist
   */
  const createPlaylist = async (newMessages, initialize) => {
    console.log(`createPlaylist initialize ${initialize} ${newMessages.length} 
    newMessages messagesOffset ${messagesOffsetRef.current} currentCollection:`, currentCollection)
    if (initialize) {
      dispatch(setMessages(newMessages))
      setMessagesOffset(newMessages.length)
      console.log(`...createPlaylist initialize true set playerState to PLAYER_STATES.SONG`)
      dispatch(setPlayerState(PLAYER_STATES.SONG))
    } else {
      dispatch(setMessages([...messages, ...newMessages]))
      setMessagesOffset(messagesOffsetRef.current + newMessages.length)
    }
    //const rsaKeyPair = await createRsaPublicKey()
    //console.log('...public key created')
    const newPlayList = await buildNewPlaylistEntries(newMessages)
    if (newPlayList.length) {
      const updatedPlayList = initialize ? newPlayList : [...playList, ...newPlayList]
      completeCreatePlaylist(updatedPlayList, initialize)
    }
  }

  /**
   * 
   * @param {*} updatedPlayList The playList as just updated in createPlaylist
   * @param {*} initialize      If true and requestedSong is not null then set the playListIndex to the
   *                            entry corresponding to the requested Message
   */
  const completeCreatePlaylist = (updatedPlayList, initialize) => {
    console.log(`**************completeCreatePlaylist playerState ${playerState} playListLength ${updatedPlayList.length} 
      initialize ${initialize}`)
    if (initialize) {
      if (requestedSong) {
        dispatch(setPlayList(updatedPlayList))
        const ix = updatedPlayList.findIndex(pl => pl.messageId === requestedSong)
        if (ix !== -1) {
          dispatch(setPlayListIndex(ix))
          dispatch(setCurrentCollection(null))

        } else {
          dispatch(setPlayListIndex(0))
        }
      } else {
        dispatch(setPlayList(updatedPlayList))
      }

    } else {
      dispatch(setPlayList(updatedPlayList))
    }
    if (requestedSong) {
      console.log(`**** setPlayerMode from completeCreatePlaylist ${PLAYER_MODES.SWIPE}`)
      dispatch(setPlayerMode(PLAYER_MODES.SWIPE))
    }

  }

  /**
   * Create the playlist from the collection. If that is null, reset the currentCollection.
   * Then call requestMessages
   * @param {*} collection
   */
  const collectionPlaylist = async (collection) => {
    console.log('collectionPlaylist', collection)
    setError('')
    dispatch(setCurrentCollection(collection))
    /*
    if (collection) {
      console.log(`**** setPlayerMode from collectionPlaylist ${PLAYER_MODES.LIST}`)
      dispatch(setPlayerMode(PLAYER_MODES.LIST))
    }
    */
    getInitialMessages(collection, true)

  }

  /**
   * Always display the HarmonizePlayer
   * @returns 
   */
  const displayHarmonizePlayer = () => {
    return (
      <HarmonizePlayer
        messageSocket={getSocket}
        setCollectionPlaylist={(col) => collectionPlaylist(col)}
      />
    )
  }

  const isAccessAllowed = (currentRoom) => {
    const { accessType, user } = currentRoom
    return isAdminUser() ||
      accessType !== ACCESS_TYPES.PRIVATE || user === userId
  }

  const updatePlayListSelection = (messageId) => {
    console.log(`selected messageID ${messageId}`, playList)
    const selectedIndex = playList.findIndex(pl => pl.messageId === messageId)
    if (selectedIndex !== -1) {
      dispatch(setPlayListIndex(selectedIndex))
      dispatch(setPlayCurrentSong(playList[selectedIndex].name))
    }
  }

  const displayPost = (msg, fromSupport) => {
    if (msg && !reactorPlay) {
      return (
        <DisplayHarmonizePost
          fromSupport={fromSupport}
          key={msg._id}
          content={msg}
          selected={() => {
            updatePlayListSelection(msg._id)
          }}
          room={currentRoom}
          messageSocket={socket}
          displayTitle={playerMode === PLAYER_MODES.POST}
          editPost={() =>
            history.push(`/CreatePost/${msg._id}`)
            //setEditingMessageId(msg._id)}
          }
        />
      )
    }
  }

  /**
   * If we are crawled by Googlebot then return all posts as in LIST mode.
   * Otherwise return one or more messages using displayPost.
   * 
   * @returns 
   */
  const displayMessagesForMode = () => {
    console.log(`\n---> displayMessagesForMode ${messages.length} messages mode ${playerMode} state ${playerState}`)

    if (isGooglebot(window.navigator.userAgent)) {
      return <GoogleBotPage messages={messages} />
    }

    if (requestedSong) {
      switch (playerMode) {
        case PLAYER_MODES.SWIPE:
          if (!reactorPlay) {
            return <SwipeCard socket={socket} setCollectionPlaylist={(col) => collectionPlaylist(col)} />
          } else {
            return null
          }
        case PLAYER_MODES.GRID:
          if (!reactorPlay) {
            return <StudioGrid />
          } else {
            return null
          }
        default:
          return displayPost(messages[0])
      }
    }
    /*
        if (endOfMessages && !messages.length) {
          return displayNoSongs()
        }
        */

    if (!showCollections) {
      switch (playerMode) {
        case PLAYER_MODES.SWIPE:

          return <SwipeCard socket={socket} setCollectionPlaylist={(col) => collectionPlaylist(col)} />

        case PLAYER_MODES.GRID:
          if (fullscreen) {
            return messages.map((m => displayPost(m)))
          } else if (!reactorPlay) {
            return <StudioGrid />
          } else {
            return null
          }
        case PLAYER_MODES.POST:
          return messages.map((m => displayPost(m)))


        case PLAYER_MODES.LIST:
          return messages.map((m => {
            return displayPost(m)
          }))
        default:
          const { accessType } = currentRoom
          return displayPost(messages.find(m => m._id === (!playList.length && accessType === ACCESS_TYPES.PRIVATE ? messages[playListIndex].messageId : playList[playListIndex].messageId)))
      }
    }
    //}

  }


  /** If in player mode, we only ever display the post for the current audio */
  const displayOnCondition = () => {
    if (loadFailed) {
      return (
        <p style={{ fontWeight: 'bold', textAlign: 'center' }}>
          Unable to load this room
        </p>
      )
    } /*else if (loading) {
      return (
        <div style={{ backgroundColor: 'white', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <TimerProgress label='Loading...' />
        </div>)
    } */ else {
      console.log(`[]Studio displayOnCondition isAccessAllowed ${isAccessAllowed(currentRoom)}`)
      if (!isAccessAllowed(currentRoom)) {
        return (
          <p style={{ fontWeight: 'bold', textAlign: 'center', color: 'white' }}>
            This Studio is private
          </p>
        )
      } else {
        return (
          <div>
            <div >
              {displayMessagesForMode()}
            </div>
            {isSignedIn() && showChat ? <div style={{ position: 'fixed', bottom: '4vh', width: '100%' }}>
              <Chat socket={getSocket} setError={setError} currentRoomOwner={currentRoomOwner} /></div> : null}
            {/*displayAddPost()*/}
          </div>
        )
      }
    }
  }

  const displaySignIn = () => {
    if (!isGooglebot(window.navigator.userAgent) && !isSignedIn() && forceSignIn && currentRoom && currentRoomOwner) {
      const { name: roomName } = currentRoom
      const { handle } = currentRoomOwner
      const returnPath =
        requestedSong ? `/@${handle}/song/${requestedSong}` :
          requestedCollection ? `/collection/${requestedCollection}`
            : `/@${handle}/${roomName}`
      return <DisplaySignIn returnPath={returnPath} />
    }
  }

  const displayMusic = () => {
    console.log('[]Studio displayMusic')
    return (
      <div><div style={{ position: 'sticky', top: 0, zIndex: '1' }}>
        {displayHarmonizePlayer()}
      </div>
        <div style={{
          paddingBottom: showChat ? '30vh' : reactorPlay ? '0' : '100px',
          backgroundColor: reactorPlay ? 'white' : primaryColor,
        }}>{displayOnCondition()}</div></div>
    )
  }

  const displayAiOrSupport = () => {
    if (showAi) {
      return (

        <div style={{
          position: 'absolute', top: '5em', width: '100%', left: 0,
          backgroundColor: 'white', paddingLeft: '0.5em', paddingRight: '0.5em'
        }}>
          <AIChat category='Support' ownerOnly={true} chatHeight={veryNarrow ? '68vh' : '80vh'} useSessionId={chatSessionId} /> </div>
      )

    } else {
      return (<div><div style={{ paddingBottom: '5vh' }}>
        {messages.map(msg => displayPost(msg, true))}
      </div>
        {/*displayAddPost()*/}
      </div>)
    }
  }

  const displaySupport = () => {
    return (
      <div>
        <HarmonizeHeader />
        {displayAiOrSupport()}
        <Footer />
      </div>)
  }

  const swipeOrOther = () => {
    if (playList && playList.length) {
      const { category } = currentRoom
      const isMyStudio = currentRoomOwner && currentRoomOwner.user === userId
      console.log(`swipeOrOther isMyStudio ${isMyStudio} playerMode ${playerMode} ${userId} `,
        currentRoomOwner)
      if (isGooglebot(window.navigator.userAgent)) {
        return <GoogleBotPage messages={messages} />
      }
      switch (playerMode) {
        case PLAYER_MODES.SWIPE:
          return <SwipeCard socket={socket} setCollectionPlaylist={(col) => collectionPlaylist(col)} />

        default:
          if (isMyStudio || process.env.REACT_APP_INTRODUCTION === 'true') {
            //if (createPost || editingMessageId) {
            //  return displayCreatePost()
            if (category === 'Music' || category === 'Video') {
              return displayMusic()
            } else {
              return displaySupport()
            }
          } else {
            return <SwipeCard socket={socket} setCollectionPlaylist={(col) => collectionPlaylist(col)} />
          }
      }
    }
  }
  const displayLoading = () => {
    //console.log(`[]Studio displayLoading `)
    return (
      <div>
        <div style={{
          backgroundImage: `url(${harmony})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          opacity: 1

        }} />

        <Footer />
      </div>
    )
  }

  const displayEmpty = () => {
    if (endOfMessages && !playList.length) {
      return <SwipeCard socket={socket} setCollectionPlaylist={(col) => collectionPlaylist(col)} />
    }
  }
  /**
   * The sticky position only works if:
   * - zIndex is set to >0. WIthout this content scrolls over the player.
   * - The height of the container is set larger than the scrolled container. Without this the sticky only stays
   *   through part of the list
   * @returns 
   */
  const displayMain = () => {
    if (currentRoom) {
      console.log('Studio displayMain currentRoom', currentRoom)
      if (noAccess) {
        return (
          <div>
            {displayLoading()}
            {displayNoAccess()}
          </div>
        )
      } else {
        return (
          <div>
            <ErrorLine error={error} />
            {swipeOrOther()}
            {displayNoAccess()}
            {displaySignIn()}
            {displayEmpty()}
          </div>
        )
      }

    } else {
      return null
    }
  }

  /**
   * Put the Studio collection at the top -- this gets us back to all songs in the studio.
   * Push Liked with this User's id so that if we switch Studios we don't use this Liked list.
   * @param {*} collections 
   * @param {*} owner 
   */
  const addFixedPlaylists = (roomOwner, collections) => {
    collections.push({ ...STUDIO_COLLECTION, user: userId })
    const { user } = roomOwner
    if (user === userId) {
      collections.push({ ...LIKED_COLLECTION, user: userId })
    }
  }

  /**
   * Get the collections associated with the current Studio, and add
   * the fixed playlist or playlists to that list of collections.
   * @param {*} collectionsRoom 
   */
  const fetchStudioCollections = async (roomOwner, collectionsRoom) => {
    if (!isGooglebot(window.navigator.userAgent)) {
      console.log('fetchStudioCollections', collectionsRoom)
      const { _id } = collectionsRoom
      try {
        const coll = await getCollections(_id)
        addFixedPlaylists(roomOwner, coll)
        console.log('...fetchStudioCollections', coll)
        dispatch(setCollections(coll))
        await getDefaultPlaylist(coll)
      } catch (error) {
        console.error(error)
      }
    }
  }

  const getDefaultPlaylist = async (collections) => {
    if (!isArtistStudio(currentRoomOwner, userId) && isMyStudio(currentRoomOwner, userId)) {
      console.log(`getDefaultPlaylist ${collections.length} collections`, collections)
      const defaultCollection = collections.length === 1 ? collections[0] : collections.find(col => col.name !== 'Liked')
      await collectionPlaylist(defaultCollection)
    }
  }

  /**
   * @returns true if a specific Playlist or Song is requested
   */
  const isSpecificRequest = () => {
    return requestedCollection || requestedSong
  }

  /**
   * 
   * @returns true if a specific song is requested
   */
  const isSpecificSongRequest = () => {
    return requestedSong
  }

  /** Anonymous Studio access is allowed because all media is then played
   * in Preview mode. Therefore there is no difference between this and
   * signed-in access *EXCEPT* that there is no socket connection made
   * to a Social Service room.
   */
  const connectAnonymous = async (room, roomOwner) => {
    getInitialMessages(null, false, { room, roomOwner })
    await fetchStudioCollections(roomOwner, room)
  }

  const displayNoAccess = () => {
    if (noAccess) {
      return (
        <Snackbar
          open={noAccess}
          autoHideDuration={3000}
          onClose={() => {
            setNoAccess(false)
            history.replace('/')
          }}
          message='You do not have access to this studio'
          anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        >
        </Snackbar>
      )
    }
  }

  /** No longer needed because we don not track studio views
  const updateStudio = async (room, roomOwner, user) => {
    const { _id, category } = room
    let updatedRoom = { ...room, roomOwner }

    if (userId !== user) {
      //This call to the Core Service returns just the Room, not the associated Asset,
      //so until that todo above is done, we need to put the category back into currentRoom.
      const incrementedRoom = await incrementRoomViews(_id)
      updatedRoom = { ...incrementedRoom, category, roomOwner }
    }

    dispatch(setCurrentRoom(updatedRoom, 3))
    console.log('[]Studio ...currentRoom is now', updatedRoom)
    if (isAccessAllowed(updatedRoom)) {
      return updatedRoom
    } else {
      console.log('[]Studio access to currentRoom BLOCKED', updatedRoom)
      setNoAccess(true)
    }
  }
  */

  /**
   * The channel address for a publicAccess room that is being accessed anonymously is:
   * wss://service.harmonize.social/[roomId]=[apikey]
   * 
   * The channel address for every other room  is:
   * wss://service.harmonize.social/[channelName]/[_id]/[b64UserId]
   * 
   * where
   * channelName and _id are taken from the room
   * b64UserId      is the signed-in User's _id, b64 encoded
   * @todo Move Asset category into Room so that when Room is retrieved it always has category
   * 
   * @param {*} room
   */
  const connectOwnerAndSocket = async (room) => {
    const { accessType, _id } = room
    console.log(`connectOwnerAndSocket userId ${userId} `, room)
    if (!isAccessAllowed(room)) {
      console.log('[]Studio access to currentRoom BLOCKED', room)
      setNoAccess(true)
    } else {
      const roomOwner = await getRoomOwner(room)
      if (!isSignedIn() && accessType !== ACCESS_TYPES.PUBLIC) {
        await connectAnonymous(room, roomOwner)
      } else {
        if (accessType === ACCESS_TYPES.PUBLIC) {
          console.log(`...connect to public room `)
          connectNew(roomOwner, room, `/${_id}=${userId ? userId : 0}=${process.env.REACT_APP_API_KEY}`)
        } else if (isSignedIn()) {
          connectNew(roomOwner, room)
        } else {
          throw new Error('FATAL ERROR: no valid socket connection sequence')
        }
        await fetchStudioCollections(roomOwner, room)
      }
    }
  }

  const connectError = (exc) => {
    console.error('connectError', exc)
    const { status } = exc
    if (status === 401) {
      history.push('/SignIn')
    } else if (status === 403) {
      history.replace('/')
    } else {
      displayError(exc, setError, 104)
    }
  }

  const connectRoom = async () => {
    console.log(`[]Studio connectRoom playerState ${playerState} currentArtist`, currentArtist)
    if (!isSpecificSongRequest()) {// || (playerState !== PLAYER_STATES.SONG && playerState !== PLAYER_STATES.STUDIO)) {
      console.log(`[]Studio connectRoom set playerState to PLAYER_STATES.INIT`)
      dispatch(setPlayerState(PLAYER_STATES.INIT))
    }

    setLoadFailed(false)

    const { handle: roomToGetHandle, selectedRoom: roomToGet } = currentArtist

    console.log(`\n***[]Studio connectRoom ${roomToGet} roomToGetHandle ${roomToGetHandle} requestedSong ${requestedSong}`)
    if (!roomToGet) {
      displayError('No valid room was provided', setError)
      dispatch(setMessages())
      setLoadFailed(true)
    } else {
      try {
        const room = await getAndConnectRoom(
          roomToGet,
          roomToGetHandle,
          history,
          dispatch,
          (exc) => connectError(exc)
        )
        if (room) {
          console.log('getAndConnectRoom returned', room)
          //dispatch(setPlayerState(PLAYER_STATES.STUDIO))
          await connectOwnerAndSocket(room)
          setLoadFailed(false)
          dispatch(setPlayListIndex(0))
        } else {

          setLoadFailed(true)
        }

      } catch (error) {

        setLoadFailed(true)
        displayError(error, setError, 105)
      }

    }
  }

  const safeEmit = (type, message) => {
    if (socket) {
      socket.emit(type, message)
    }
  }

  const handleVisibilityChange = () => {
    //console.log(`visibilityChange ${document.visibilityState}`)
    if (document.visibilityState === 'hidden') {
      console.log('---> Studio disconnecting due to visibility change')
      disconnectExisting()
    } else if (currentRoom && !socket) {
      console.log('---> Studio Reconnecting due to visibility change')
      connectExisting()
    }
    setVisible(document.visibilityState)
  }

  useEffect(() => {
    console.log(`[]Studio useEffect userId ${userId} currentArtist`, currentArtist)
    //dispatch(setMessages([]))
    connectRoom()
    scrollToTop()
    window.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      console.log('remove visibilityChange listener')
      window.removeEventListener('visibilitychange', handleVisibilityChange)
      disconnectChannel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  /**
   * Called when the requestMessages response from Social Service is received. 
   */
  useEffect(() => {
    console.log(`\n []Studio useEffect fullscreen ${fullscreen} requestedSong ${requestedSong} requestedMessages ${requestedMessages ? requestedMessages.length : 'null'}`, requestedMessages)
    if (requestedMessages) {
      if (requestedMessages.length) {
        createPlaylist(requestedMessages, true).then(() => {
          if (requestedMessages.length < parseInt(process.env.REACT_APP_MESSAGES_BLOCK_SIZE)) {
            console.log(`\n*** end of messages, offset ${messagesOffsetRef.current} new block length ${requestedMessages.length}`)
            dispatch(setEndOfMessages(true))
          }
          setRequestedMessages(null)
        })
      } else {
        if (!messages.length) {
          dispatch(setPlayerState(PLAYER_STATES.EMPTY_STUDIO))
        }
        dispatch(setEndOfMessages(true))
        setMessagesOffset(0)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedMessages])

  const scrollToTop = () => {
    if (ref.current) {
      ref.current.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  /**
   * This is the only way to do it. All those posts that show a div handling onScroll are
   * not relevant when using Material UI.
   */
  useEffect(() => {
    console.log(`\n []Studio useEffect playerMode ${playerMode} currentRoom`, currentRoom)
    if (currentRoom) {
      const { name } = currentRoom
      const handle = currentRoomOwner ? currentRoomOwner.handle : undefined
      const pageName = handle ? `@${handle}` : `${name}`
      document.title = `Harmonize | ${pageName}`
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRoom])

  useEffect(() => {
    console.log(`[]Studio joinedStudio ${joinedStudio}`)
    if (joinedStudio) {
      onJoined()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joinedStudio])
  useEffect(() => {
    //console.log('\n ----------- useEffect 3')
    addCommentToMessage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentToAdd])

  useEffect(() => {
    //console.log('\n ----------- useEffect 4')
    deleteCommentFromMessage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentToDelete])

  useEffect(() => {
    //console.log('\n ----------- useEffect 5')
    updateMessage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageToUpdate])

  useEffect(() => {
    //console.log('\n ----------- useEffect 6')
    if (messageToCreate) {
      createMessage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageToCreate])

  useEffect(() => {
    if (messageToDelete) {
      deleteMessage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageToDelete])

  useEffect(() => {
    //console.log('\n ----------- useEffect 6')
    updateLike(messageToLike)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageToLike])


  useEffect(() => {
    //console.log('\n ----------- useEffect 8')
    console.log(`[]Studio useEffect showChat ${showChat}`)
    if (!showChat) {
      leaveChat()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showChat])

  /**
   * Don't reset query and queryReady when the fetch completes because subsequent calls
   * will then not execute.
   */
  useEffect(() => {
    console.log(`[]Studio useEffect 
    queryReady ${queryReady} query ${JSON.stringify(query)} 
    fetchStart ${fetchStart} currentRoom`, currentRoom)
    if (queryReady && query) {
      console.log(`   []Studio now FETCH`)
      dispatch(setPlayerState(PLAYER_STATES.SONG))
      fetchSongsAndVideo(dispatch)
        .then(() => {
          //dispatch(setQuery(null))
          //setQueryReady(false)
        })
        .catch(error => {
          //dispatch(setQuery(null))
          //setQueryReady(false)
          dispatch(setFetchInProgress(false))
          displayError(error, setError, 106)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryReady, query, fetchStart])
  /**
   * If the user enters a protected Studio without being signed in, 
   * connectRoom executes but does not connect to the Social Service.
   * In this case hasAccessToken is false. When the sign in completes, account is updated and that triggers this method again.
   * At that point because hasAccessToken is still false, the connectRoom executes again. This time it does connect
   * to the Social Service, getting the initial messages.
   *
  useEffect(() => {
    console.log(`[]Studio useEffect userId ${userId} currentArtist`, currentArtist)
    dispatch(setMessages([]))
    connectRoom()
    if (isSignedIn()) {
      setHasAccessToken(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  */

  useEffect(() => {
    if (refetchMessageId) {
      console.log(`[]Studio useEffect refetchMessage ${refetchMessageId}`)
      refetchMessage(refetchMessageId, currentRoom, dispatch)
        .then(() => dispatch(setRefetchMessageId(null)))
        .catch(error => {
          console.error(`Attempt to refetch ${refetchMessageId} FAILED`, error)
          dispatch(setRefetchMessageId(null))
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetchMessageId])

  if (isGooglebot(window.navigator.userAgent)) {
    return <GoogleBotPage />
  }
  return (
    <div style={{
      backgroundColor: 'white',
      height: '100%', width: '100%', position: 'absolute', top: 0
    }}>
      {noAccess || playList.length || endOfMessages ? displayMain() : displayLoading()}

    </div>)



}

